"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetDynamicsInstallationStateQuery = void 0;

var _EmptyGatewayApi = require("../../EmptyGatewayApi");

var dynamicsInstallation = _EmptyGatewayApi.emptyGatewayApi.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getDynamicsInstallationState: build.query({
        query: function query() {
          return "/dynamics/oauth/state";
        }
      })
    };
  }
});

var useGetDynamicsInstallationStateQuery = dynamicsInstallation.useGetDynamicsInstallationStateQuery;
exports.useGetDynamicsInstallationStateQuery = useGetDynamicsInstallationStateQuery;